<template>
  <div>
    <div class="input-tab">{{ $t('comparisonFeature.resources.tab') }}</div>
    <div class="input-card">
      <div class="title">
        {{ $t('comparisonFeature.resources.title') }}
      </div>
      <div class="input">
        <input
          type="text"
          :placeholder="$t('comparisonFeature.resources.inputPlaceholder')"
          class="form-control"
          v-model.trim="resourceQuery"
          :class="{ warning: !!warningTextType }"
          @keydown="onInputKeydown"
          @keyup.enter="enterInput"
        />
        <span
          v-show="resourceQuery && !warningTextType"
          @click="addToResourceQueryList"
          class="add"
        >
          {{ $t('comparisonFeature.resources.inputBtn') }}
        </span>
      </div>
      <div v-show="!!warningTextType" class="warning-text">
        {{
          warningTextType === 1
            ? $t('comparisonFeature.resources.inputLimitErrorMsg')
            : warningTextType === 2
            ? $t('comparisonFeature.resources.inputDuplicateErrorMsg')
            : $t('searchBox.warningText')
        }}
      </div>
      <div v-show="!warningTextType && !!tipTextType" class="tip-text">
        {{ $t('comparisonFeature.resources.inputLimitRemindingMsg') }}
      </div>
      <div class="results">
        <div
          v-for="(item, index) of comparisonResourceList"
          :key="item"
          class="result-card"
        >
          <span class="result-card__text">{{ item }}</span>
          <fa
            icon="times-circle"
            class="result-card__remove-icon"
            @click="removeFromResourceQueryList(index)"
          ></fa>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import {
  INTERNET_NUMBER_RESOURCE_TYPE,
  validateInternetNumberType,
  normalizeInternetNumber,
} from '../../utils/validateInternetNumberResource';

export default {
  data() {
    return {
      resourceQuery: '',
      warningTextType: 0, // 0: no text, 1: up to limit number, 2: duplicate, 3: invalid input
      tipTextType: 0, // 0: no text, 1: up to limit number,
    };
  },

  computed: {
    ...mapState(['comparisonResourceList', 'selectedComparisonToolList']),
  },

  methods: {
    ...mapMutations([
      'addComparisonResourceIntoList',
      'removeFromComparisonResourceList',
    ]),

    addToResourceQueryList() {
      const validateResult = validateInternetNumberType(this.resourceQuery);

      if (validateResult === INTERNET_NUMBER_RESOURCE_TYPE.INVALID) {
        this.warningTextType = 3;
        return;
      } else {
        this.resourceQuery = normalizeInternetNumber(this.resourceQuery);

        const isExistingResource = this.comparisonResourceList.includes(
          this.resourceQuery
        );

        if (this.comparisonResourceList.length > 5) {
          this.warningTextType = 1;
        } else if (isExistingResource) {
          this.warningTextType = 2;
        } else {
          if (this.comparisonResourceList.length >= 3) this.tipTextType = 1;

          this.addComparisonResourceIntoList(this.resourceQuery);
          this.resourceQuery = '';

          if (this.selectedComparisonToolList.length) {
            // fetch data to generate comparison results if comparison tools have been selected
            this.$emit('fetchComparisonWidgets');
          }
        }
      }
    },

    removeFromResourceQueryList(index) {
      this.removeFromComparisonResourceList(index);

      if (this.warningTextType) this.warningTextType = 0;

      if (this.comparisonResourceList.length <= 3) this.tipTextType = 0;
    },

    normalizeASN(val) {
      const isAllDigital = val.match(/^\d+$/);
      if (isAllDigital) return `AS${val}`;
      return val;
    },

    onInputKeydown() {
      if (this.warningTextType) this.warningTextType = 0;
    },

    enterInput() {
      this.addToResourceQueryList();
    },
  },
};
</script>

<style scoped lang="scss">
.input-tab {
  width: 5rem;
  height: 2.75rem;
  line-height: 2.75rem;
  background-color: $apnic-blue;
  color: white;
  font-weight: 600;
  text-align: center;
}
.input-card {
  position: relative;
  background-color: white;
  width: 100%;
  padding: 1rem;

  .title {
    padding-bottom: 0.5rem;
    font-weight: 600;
    line-height: 1.5rem;
  }

  .input {
    position: relative;
    width: 100%;
    max-width: 300px;

    input {
      width: 100%;
      padding: 0.5rem;
      padding-right: 0;
    }

    input::placeholder {
      font-size: 1rem;
    }

    .warning {
      color: $warning-red;
      border-color: $warning-red;
      box-shadow: none;
    }

    .add {
      position: absolute;
      top: 0.5rem;
      right: 1rem;
      color: $apnic-blue;
      font-weight: 600;

      &:hover {
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }

  .warning-text {
    position: absolute;
    color: $warning-red;
    font-size: 0.75rem;
  }

  .tip-text {
    position: absolute;
    color: $text-grey;
    font-size: 0.75rem;
  }

  .results {
    display: flex;
    flex-wrap: wrap;
    margin: 0.75rem 0;

    .result-card {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0.5rem 0;
      margin-right: 1rem;
      padding: 0 0.5rem;
      min-width: 7rem;
      height: 2.75rem;
      line-height: 2.75rem;
      box-shadow: $card-shadow;

      &__text {
        color: $text-black;
      }

      &__remove-icon {
        color: $icon-grey;
        margin-left: 0.5rem;
        cursor: pointer;
      }
    }
  }
}
</style>
